import loadable from '@loadable/component';

export const LazyCreateBabyRegistry = loadable(() => import(/* webpackChunkName: "content/createbabyregistry" */ '.'));
